import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, Routes } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';

import { HomeComponent } from './components/home/home.component';
import { EditorComponent } from './components/editor/editor.component';

import { SignerComponent } from './components/signer/signer.component';
import { SettingsComponent } from './components/settings/settings.component';
import { ContactsComponent } from './components/contacts/contacts.component';
import { LoginComponent } from './components/login/login.component';
import { LauncherComponent } from './components/launcher/launcher.component';
import { EncryptionComponent } from './components/encryption/encryption.component';
import { WebpConverterComponent } from './components/webp-converter/webp-converter.component';
import { VideoConverterComponent } from './components/video-converter/video-converter.component';
import { GitComponent } from './components/git/git.component';
import { authGuard } from './auth.guard';
import { authInterceptor } from './auth.interceptor';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'launcher', component: LauncherComponent, canActivate: [authGuard] },
  { 
    path: 'pdf-signer', 
    canActivate: [authGuard],
    children: [
      { path: '', component: HomeComponent },
      { path: 'editor/:id', component: EditorComponent },
      { path: 'settings', component: SettingsComponent },
      { path: 'contacts', component: ContactsComponent },
    ]
  },
  { path: 'encryption', component: EncryptionComponent, canActivate: [authGuard] },
  { path: 'webp-converter', component: WebpConverterComponent, canActivate: [authGuard] },
  { path: 'video-converter', component: VideoConverterComponent, canActivate: [authGuard] },
  { path: 'git', component: GitComponent, canActivate: [authGuard] },
  { path: 'sign/:token', component: SignerComponent }, // Public signing page
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: '**', redirectTo: 'login' }
];

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimations(),
  ]
};
